import React, {useEffect} from 'react'
import { useSelector } from 'react-redux'

export default function ModalCloseConfirmation(props) {
    const { confirmCb } = useSelector((state) => state.modalState.confirmModal)
    const discardHandler = () => {
        window.$("#close-modal-confirmation").modal("hide")
        window.$(".modal-backdrop.fade.show")[0].classList.remove("dim-modal")

    }
    window.closeCofirmModal = discardHandler
    const confirmHandler = () => {
        confirmCb()
        discardHandler()
        props.setCloseModalConfirmCb(null)
    }
    return (
        <div className="modal fade" id="close-modal-confirmation" >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className='close-modal-confirm-body'>
                        <div className='d-flex flex-column justify-content-center p-4'>
                            <span className=''>
                                Are you sure you want to close the modal? This action will result in losing any changes made.
                            </span>
                            <div className='d-flex justify-content-end mt-3'>
                                <button id="close-btn" className='mr-2 btn btn-danger' onClick={confirmHandler}>Close anyway</button>
                                <button id="discard-btn" className='btn btn-secondary' onClick={discardHandler}>Take be back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
